

import { ColumnDef } from "@tanstack/react-table";
import { InventoryItem } from "../types";
import { Checkbox } from "@repo/ui/components/ui/checkbox";
import { DataTableColumnHeader } from "./data-table-column-header";

export const columns: ColumnDef<InventoryItem>[] = [
  {
    id: "select",
    header: ({ table }) => (
      <Checkbox
        checked={table.getIsAllPageRowsSelected()}
        onCheckedChange={(value) => table.toggleAllPageRowsSelected(!!value)}
        aria-label="Select all"
      />
    ),
    cell: ({ row }) => (
      <Checkbox
        checked={row.getIsSelected()}
        onCheckedChange={(value) => row.toggleSelected(!!value)}
        aria-label="Select row"
      />
    ),
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "type",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Type" />,
  },
  {
    accessorKey: "genre",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Genre" />,
  },
  {
    accessorKey: "espece",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Espèce" />,
  },
  {
    accessorKey: "cultivar",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Cultivar" />,
  },
  {
    accessorKey: "countSubject",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Nb de sujets" />,
  },
  {
    accessorKey: "hauteur",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Hauteur" />,
  },
  {
    accessorKey: "diametre",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Diamètre" />,
  },
  {
    accessorKey: "address",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Adresse" className="w-[200px]" />,
  },
  {
    accessorKey: "ville",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Ville" className="w-[200px]" />,
  },
  {
    accessorKey: "pays",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Pays" />,
  },
  {
    accessorKey: "codeSite",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Code Site" />,
  },
  {
    accessorKey: "numSujet",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Identification" />,
  },
  {
    accessorKey: "createdAt",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Date inventaire initial" />,
  },
  {
    accessorKey: "updatedAt",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Dernière intervention" />,
  },
  {
    accessorKey: "username",
    header: ({ column }) => <DataTableColumnHeader column={column} title="Recenseur" />,
  },
]
